import React, { Component } from 'react';

// Import module css
import styles from './Section.module.css';

class Section extends Component {

  render() {
    const newClass = this.props.newClass;

    return (
      <section
        id={this.props.id}
        className={`row no-gutters ${styles.sectionRow} ${this.props.hr ? styles.sectionHr : ''} ${newClass ? styles[newClass] : '' }`}
        style={
          (this.props.bgColor !== undefined)
            ? {backgroundColor: this.props.bgColor}
            : {}
        }
      >
        {this.props.children}
      </section>
    )
  }
}

export default Section;